<template>
  <b-form-group
    label="Fuar Adresi"
    label-for="summary"
  >
    <b-form-textarea
      id="summary"
      v-model="dataItem.fair_adress"
      placeholder="Fuar Adresi.."
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormTextarea,
} from 'bootstrap-vue'

export default {
  name: 'FairAdress',
  components: {
    BFormGroup,
    BFormTextarea,
  },
  computed: {
    dataItem() {
      return this.$store.getters['fairs/dataItem']
    },
  },
}
</script>
